import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pause-popover',
  templateUrl: './pause-popover.component.html',
  styleUrls: ['./pause-popover.component.scss'],
})
export class PausePopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
